import React from 'react';
import BaseDashboard from '../../components/BaseDashboard';
import InboundScheduleForm from '../components/InboundScheduleForm';
import HistoryView from './HistoryView';
import MonthView from './MonthView';
import ReceivingView from './ReceivingView';

/**
 * Dashboard for inbound truck operations
 * Extends the BaseDashboard with inbound-specific configuration
 */
const InboundDashboard = ({ initialView }) => {
  // Define view components mapping for the base dashboard
  const viewComponents = {
    month: (props) => <MonthView {...props} mode="inbound" />,
    receiving: ReceivingView,
    history: (props) => <HistoryView {...props} mode="inbound" />
  };
  
  // Calculate dashboard stats specific to inbound trucks
  const calculateStats = (truckData) => {
    return {
      scheduled: truckData.filter(truck => !truck.arrival_datetime && !truck.completed_at).length,
      arrived: truckData.filter(truck => truck.arrival_datetime && !truck.started_at).length,
      inProgress: truckData.filter(truck => truck.started_at && !truck.completed_at).length,
      completed: truckData.filter(truck => truck.completed_at && !truck.putaway_at).length,
      lateArrivals: truckData.filter(truck => 
        !truck.arrival_datetime && 
        new Date(truck.scheduled_at) < new Date() && 
        !truck.completed_at
      ).length
    };
  };
  

  return (
    <BaseDashboard
      initialView={initialView}
      mode="inbound"
      apiEndpoint="inbound-trucks"
      scheduleFormComponent={InboundScheduleForm}
      viewComponents={viewComponents}
      calculateStats={calculateStats}
      socketEventName="truck-schedule-update"
    />
  );
};

export default InboundDashboard;